import React, {useEffect, useRef, useState} from 'react';
import {useResize} from "../../hooks/useResize";
import clsx from "clsx";

export interface IGradingSystemItem {
    name: string;
    info?: string;
    coordinates?: {
        desktop?: {
            top: string;
            left: string;
            right: string;
        };
        mobile?: {
            top: string;
            left: string;
            right: string;
        };
    };
    id: number;
}
const GradingSystemItem: React.FC<IGradingSystemItem> = ({name, info, coordinates, id}) => {
    const [open, setOpen] = useState(false);
    const itemRef = useRef<HTMLDivElement>(null);
    const width = useResize();
    const isMobile = width <= 992 && typeof window !== 'undefined';
    const isDesktop = width <= 1320 && typeof window !== 'undefined';
    const currentCoordinates = isMobile
        ? coordinates?.mobile
        : coordinates?.desktop;

    const handleOpenInfo = () => {
        if (!isDesktop) return;
        setOpen(!open);
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (itemRef.current && !itemRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);
    return (
        <div className={"grading-system__item-wrapper "} ref={itemRef}>
            <div className={clsx("grading-system__item ", id > 3 && 'grading-system__item-reverse')} style={{
                top: currentCoordinates?.top,
                left: currentCoordinates?.left,
                right: currentCoordinates?.right,
            }}>
                <div className={clsx("grading-system__item-info",
                    open && 'grading-system__item-info--open',
                    id > 3 && 'grading-system__item-info--right')}>
                    <div className="grading-system__name">{name}</div>
                    {
                        info &&
                        <div className="grading-system__info">
                            {info}
                        </div>
                    }
                </div>
                <div className={clsx('grading-system__footnote', id > 3 && 'grading-system__item-reverse')}>
                    <div className='grading-system__line'/>
                    <div className="grading-system__dot" onClick={handleOpenInfo}/>
                </div>

            </div>
        </div>
    )
}

export default GradingSystemItem;